// Inbox: three panes. Left = list with boxes and search, middle = the thread, right = the contact.
// Under ~900px the panes stack and `mobilePane` decides which one shows.

import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import type { MeResponse } from '../../api';
import { ConversationList, type Box } from './ConversationList';
import { Thread } from './Thread';
import { NewTextDialog } from './NewTextDialog';
import { Empty } from '../../components/States';

export function InboxPage({ me }: { me: MeResponse }) {
  const { conversationId } = useParams();
  const navigate = useNavigate();
  const [box, setBox] = useState<Box>('open');
  const [q, setQ] = useState('');
  const [newText, setNewText] = useState(false);
  const [mobilePane, setMobilePane] = useState<'list' | 'thread' | 'contact'>(conversationId ? 'thread' : 'list');

  useEffect(() => {
    setMobilePane(conversationId ? 'thread' : 'list');
  }, [conversationId]);

  return (
    <div className={`inbox show-${mobilePane}`}>
      <div className="pane list">
        <div className="pane-head">
          <strong className="grow">Inbox</strong>
          <button className="btn primary small" onClick={() => setNewText(true)}>
            New text
          </button>
        </div>
        <ConversationList box={box} setBox={setBox} q={q} setQ={setQ} activeId={conversationId ?? null} onSelect={(id) => navigate(`/inbox/${id}`)} />
      </div>
      {conversationId ? (
        <Thread
          key={conversationId}
          conversationId={conversationId}
          me={me}
          showContact={mobilePane === 'contact'}
          onBack={() => setMobilePane('list')}
          onToggleContact={() => setMobilePane((p) => (p === 'contact' ? 'thread' : 'contact'))}
        />
      ) : (
        <>
          <div className="pane thread-pane">
            <Empty title="Pick a conversation" hint="Choose one on the left, or start a new text.">
              <button className="btn" onClick={() => setNewText(true)}>
                New text
              </button>
            </Empty>
          </div>
          <div className="pane contact" />
        </>
      )}
      {newText && <NewTextDialog me={me} onClose={() => setNewText(false)} />}
    </div>
  );
}
